import React from 'react'
import { AxiosError } from 'axios'
import isArray from 'lodash/isArray'

import { errorParsing } from 'utils'

import styles from './ErrorModal.module.scss'

export type TErrorModalProps = {
  error?: null | AxiosError
}

export const ErrorModal = ({ error }: TErrorModalProps) => {
  const message = !!error?.response?.data?.message

  if (isArray(message)) {
    return (
      <div className={styles.error}>
        {message.map((msg, index) => (
          <p className={styles.errorParagraph} key={index}>
            {msg}
          </p>
        ))}
      </div>
    )
  }

  return error ? <div className={styles.error}>{errorParsing(error)}</div> : null
}
